import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import DanhSachChiDeleteApi from "service/danhSachChiDeleteApi";
import QuanLyThuChiHopDongApi from "service/quanLyThuChiHopDongApi";
import { pushNotification } from "utils/notifications";
import {
  getListQuanLyThuChiHopDong,
  updateDataSearch,
} from "../../../../../actions/QuanLyThuChiHopDong";
export const ModalXoa = (props) => {
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong
  );
  const [isActiveSubmit, setIsActiveSubmit] = useState(false);
  const dispatch = useDispatch();
  const deleteThuChi = () => {
    // console.log(props);
    setIsActiveSubmit(true);
    QuanLyThuChiHopDongApi.xoaPhieuThuChi(props.thuChiId).then((response) => {
      setIsActiveSubmit(false);
      if (response.data.Error == 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        dispatch(getListQuanLyThuChiHopDong(dataSearch));
        props.onHide();
        pushNotification(
          "Bạn đã xoá thành công",
          "success",
          "TOP_CENTER",
          2000
        );
      }
    });
  };

  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-delete"></i>
          </span>
          {props.IndexId == 0 && <span>Xác nhận xóa</span>}
          {props.IndexId != 0 && <span>Thông báo</span>}
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                {props.IndexId == 0 && (
                  <label
                    className="col-md-12 label-control text-left"
                    for="projectinput2"
                  >
                    Bạn có chắc chắn muốn xóa không?
                  </label>
                )}
                {props.IndexId != 0 && (
                  <label
                    className=" col-md-12 label-control text-left red"
                    for="projectinput2"
                  >
                    <span className="red">
                      Đây không phải là giao dịch cuối cùng nên không được xoá!
                    </span>
                  </label>
                )}
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        {props.IndexId == 0 && isActiveSubmit == false && (
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={deleteThuChi}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            Xác nhận
          </button>
        )}
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
